<app-charging></app-charging>
<app-modal></app-modal>

<div class="basic-data-container">
  <div class="header">
    <div class="profile-section">
      <div class="title-section">
        <h2>
          {{ role === 2 ? 'Propietario' :
          role === 1 ? 'Arrendatario' :
          'Codeudor' }} - Información Básica
        </h2>
      </div>
    </div>

    <div class="progress-steps">
      <ng-container *ngFor="let step of steps; let i = index; let last = last">
        <div class="step" [class.active]="currentStep === i + 1">
          <span class="step-number" [class.completed]="currentStep > i + 1">
            <ng-container *ngIf="currentStep > i + 1; else stepNumber">
              <i class="fas fa-check"></i>
            </ng-container>
            <ng-template #stepNumber>{{i + 1}}</ng-template>
          </span>
          {{step.title}}
        </div>

        <div class="step-separator" *ngIf="!last"></div>
      </ng-container>
    </div>
  </div>

  <!-- Formulario de Datos Básicos -->
  <form *ngIf="currentStep === 1" [formGroup]="contactDataForm" (ngSubmit)="onSubmit()" class="form-container">
    <button class="close-button" (click)="goBack()">×</button>

    <div class="note" *ngIf="steps.length > 0">
      <strong>NOTA:</strong> {{steps[0].description}}
    </div>

    <div class="person-info-container">
      <!-- Tipo de Persona -->
      <div class="form-group radio-group">
        <label>Tipo de Persona:</label>
        <div class="radio-options">
          <label *ngFor="let tipo of tiposPersona">
            <input type="radio" formControlName="personType" [value]="tipo.value">
            {{tipo.label}}
          </label>
        </div>
      </div>

      <!-- Actividad Económica (solo para persona natural) -->
      <div class="form-group radio-group" *ngIf="contactDataForm.get('personType')?.value?.toLowerCase() === 'n'">
        <label>Actividad Económica:</label>
        <div class="radio-options">
          <label>
            <input type="radio" formControlName="activityType" [value]="0">
            Empleado
          </label>
          <label>
            <input type="radio" formControlName="activityType" [value]="1">
            Independiente
          </label>
          <label>
            <input type="radio" formControlName="activityType" [value]="2">
            Pensionado
          </label>
        </div>
      </div>
    </div>

    <!-- Campos de búsqueda inicial -->
    <div class="search-section">
      <div class="form-group search-field">
        <label>Tipo de Documento: <span class="required-field">*</span></label>
        <select formControlName="idDocumentType">
          <option value="null" disabled selected hidden>Seleccione...</option>
          <option *ngFor="let type of documentTypes" [value]="type.codigoTipoDocumento">
            {{type.nombreTipoDocumento}}
          </option>
        </select>
        <small class="error-message"
          *ngIf="contactDataForm.get('idDocumentType')?.touched && contactDataForm.get('idDocumentType')?.hasError('required')">
          Este campo es requerido
        </small>
      </div>

      <div class="form-group search-field">
        <label>Número de Documento: <span class="required-field">*</span></label>
        <input type="text" formControlName="documentNumber">
        <small class="error-message"
          *ngIf="contactDataForm.get('documentNumber')?.touched && contactDataForm.get('documentNumber')?.hasError('required')">
          Este campo es requerido
        </small>
      </div>

      <div class="form-group search-field">
        <label>{{personType === 'n' ? 'Primer Apellido' : 'Razón Social'}}: <span
            class="required-field">*</span></label>

        <input type="text" formControlName="firstLastName" appUppercase>
        <small class="error-message"
          *ngIf="contactDataForm.get('firstLastName')?.touched && contactDataForm.get('firstLastName')?.hasError('required')">
          Este campo es requerido
        </small>
      </div>

      <div class="form-group search-button-container">
        <button type="button" [disabled]="!isSearchEnabled" (click)="searchPerson()" class="find-quote-button"> 
          <i class="fas fa-search search-icon"></i>
        </button>
      </div>
    </div>

    <!-- Campos adicionales después de la búsqueda -->
    <div class="additional-fields" *ngIf="showAdditionalFields">
      <!-- Campos específicos para persona natural -->
      <ng-container *ngIf="personType === 'n'">
        <div class="form-row three-columns">
          <div class="form-group">
            <label>Segundo Apellido:</label>
            <input type="text" formControlName="secondLastName" appUppercase>
          </div>
          <div class="form-group">
            <label>Primer Nombre: <span class="required-field">*</span></label>
            <input type="text" formControlName="firstName" appUppercase>
            <small class="error-message"
              *ngIf="contactDataForm.get('firstName')?.touched && contactDataForm.get('firstName')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>
          <div class="form-group">
            <label>Segundo Nombre:</label>
            <input type="text" formControlName="secondName" appUppercase>
          </div>
        </div>
      </ng-container>

      <!-- Campos comunes -->
      <!-- Segunda fila -->
      <div class="form-row three-columns">
        <div class="form-group">
          <label>Dirección: <span class="required-field">*</span></label>
          <input type="text" formControlName="address" appUppercase>
          <small class="error-message"
            *ngIf="contactDataForm.get('address')?.touched && contactDataForm.get('address')?.hasError('required')">
            Este campo es requerido
          </small>
        </div>
        <div class="form-group">
          <label>Departamento: <span class="required-field">*</span></label>
          <select formControlName="idDepartment">
            <option value="null" disabled selected hidden>Seleccione...</option>
            <option *ngFor="let dept of departments" [value]="dept.codigoDepartamento">
              {{dept.nombreDepartamento}}
            </option>
          </select>
          <small class="error-message"
            *ngIf="contactDataForm.get('idDepartment')?.touched && contactDataForm.get('idDepartment')?.hasError('required')">
            Este campo es requerido
          </small>
        </div>
        <div class="form-group">
          <label>Municipio: <span class="required-field">*</span></label>
          <select formControlName="idCity">
            <option value="null" disabled selected hidden>Seleccione...</option>
            <option *ngFor="let mun of contactMunicipalities" [value]="mun.codigoMunicipio">
              {{mun.nombreMunicipio}}
            </option>
          </select>
          <small class="error-message"
            *ngIf="contactDataForm.get('idCity')?.touched && contactDataForm.get('idCity')?.hasError('required')">
            Este campo es requerido
          </small>
        </div>
      </div>

      <!-- Tercera fila -->
      <div class="form-row three-columns">
        <div class="form-group">
          <label>Teléfono Fijo: <span class="required-field">*</span></label>
          <input type="tel" formControlName="phone">
        </div>
        <div class="form-group">
          <label>Teléfono Celular: <span class="required-field">*</span></label>
          <input type="tel" formControlName="mobilePhone">
          <small class="error-message"
            *ngIf="contactDataForm.get('mobilePhone')?.touched && contactDataForm.get('mobilePhone')?.hasError('required')">
            Este campo es requerido
          </small>
        </div>
        <div class="form-group">
          <label>Correo Electrónico: <span class="required-field">*</span></label>
          <input type="email" formControlName="email">
          <small class="error-message"
            *ngIf="contactDataForm.get('email')?.touched && contactDataForm.get('email')?.hasError('required')">
            Este campo es requerido
          </small>
          <small class="error-message"
            *ngIf="contactDataForm.get('email')?.touched && contactDataForm.get('email')?.hasError('email')">
            Ingrese un correo electrónico válido
          </small>
        </div>
      </div>
    </div>

    <button type="submit" [disabled]="!contactDataForm.valid || !showAdditionalFields" class="continue-button">
      {{ role! >= 3 || (role == 1 && codeudorNumber == 0 && radicationMainRole != 1) ? 'Grabar Información' : 'Continuar' }}
  </button>
  </form>

  <!-- Formulario de Datos del Inmueble -->
  <form *ngIf="currentStep === 2 && role === 2" [formGroup]="propertyDataForm" (ngSubmit)="onSubmit()"
    class="form-container">
    <button class="close-button" (click)="goBack()">×</button>

    <div class="note" *ngIf="steps.length > 1">
      <strong>NOTA:</strong> {{steps[1].description}}
    </div>

    <!-- Primera fila -->
    <div class="form-row three-columns">
      <div class="form-group">
        <label>Dirección del Inmueble: <span class="required-field">*</span></label>
        <input type="text" formControlName="address" appUppercase>
        <small class="error-message"
          *ngIf="propertyDataForm.get('address')?.touched && propertyDataForm.get('address')?.hasError('required')">
          Este campo es requerido
        </small>
      </div>

      <div class="form-group">
        <label>Departamento: <span class="required-field">*</span></label>
        <select formControlName="idDepartment">
          <option value="null" disabled selected hidden>Seleccione...</option>
          <option *ngFor="let dept of departments" [value]="dept.codigoDepartamento">
            {{dept.nombreDepartamento}}
          </option>
        </select>
        <small class="error-message"
          *ngIf="propertyDataForm.get('idDepartment')?.touched && propertyDataForm.get('idDepartment')?.hasError('required')">
          Este campo es requerido
        </small>
      </div>

      <div class="form-group">
        <label>Ciudad/Municipio: <span class="required-field">*</span></label>
        <select formControlName="idCity">
          <option value="null" disabled selected hidden>Seleccione...</option>
          <option *ngFor="let mun of propertyMunicipalities" [value]="mun.codigoMunicipio">
            {{mun.nombreMunicipio}}
          </option>
        </select>
        <small class="error-message"
          *ngIf="propertyDataForm.get('idCity')?.touched && propertyDataForm.get('idCity')?.hasError('required')">
          Este campo es requerido
        </small>
      </div>
    </div>

    <!-- Segunda fila -->
    <div class="form-row three-columns">
      <div class="form-group">
        <label>Tipo de Inmueble: <span class="required-field">*</span></label>
        <select formControlName="idPropertyType">
          <option value="null" disabled selected hidden>Seleccione...</option>
          <option *ngFor="let tipo of tiposInmueble" [value]="tipo.value">
            {{tipo.label}}
          </option>
        </select>
        <small class="error-message"
          *ngIf="propertyDataForm.get('idPropertyType')?.touched && propertyDataForm.get('idPropertyType')?.hasError('required')">
          Este campo es requerido
        </small>
      </div>

      <div class="form-group">
        <label>Destino del Inmueble: <span class="required-field">*</span></label>
        <select formControlName="idPropertyDestination">
          <option value="null" disabled selected hidden>Seleccione...</option>
          <option *ngFor="let destino of destinosInmueble" [value]="destino.value">
            {{destino.label}}
          </option>
        </select>
        <small class="error-message"
          *ngIf="propertyDataForm.get('idPropertyDestination')?.touched && propertyDataForm.get('idPropertyDestination')?.hasError('required')">
          Este campo es requerido
        </small>
      </div>

      <div class="form-group">
        <label>Arrendamiento del Inmueble: <span class="required-field">*</span></label>
        <select formControlName="idLeasingProperty">
          <option value="null" disabled selected hidden>Seleccione...</option>
          <option *ngFor="let arr of arrendamientosInmueble" [value]="arr.value">
            {{arr.label}}
          </option>
        </select>
        <small class="error-message"
          *ngIf="propertyDataForm.get('idLeasingProperty')?.touched && propertyDataForm.get('idLeasingProperty')?.hasError('required')">
          Este campo es requerido
        </small>
      </div>
    </div>

    <!-- Tercera fila -->
    <div class="form-row two-columns">
      <div class="form-group">
        <label>Arrendamiento Mensual: <span class="required-field">*</span></label>
        <div class="input-currency">
          <span class="currency-symbol">$</span>
          <input type="text" formControlName="leaseFeeValue" (input)="formatNumber($event)" [ngClass]="{'is-invalid': propertyDataForm.get('leaseFeeValue')?.touched && 
                                         propertyDataForm.get('leaseFeeValue')?.invalid}">
        </div>

        <small class="error-message" *ngIf="propertyDataForm.get('leaseFeeValue')?.touched && 
                      propertyDataForm.get('leaseFeeValue')?.hasError('required')">
          Este campo es requerido
        </small>
        <small class="error-message" *ngIf="propertyDataForm.get('leaseFeeValue')?.touched && 
                      propertyDataForm.get('leaseFeeValue')?.hasError('min')">
          El valor debe ser mayor a 0
        </small>
      </div>

      <div class="form-group">
        <label>Cuota de Administración: <span class="required-field">*</span></label>
        <div class="input-currency">
          <span class="currency-symbol">$</span>
          <input type="text" formControlName="administrationFee" (input)="formatNumber($event)" [ngClass]="{'is-invalid': propertyDataForm.get('administrationFee')?.touched && 
                                         propertyDataForm.get('administrationFee')?.invalid}">
        </div>
        <small class="error-message" *ngIf="propertyDataForm.get('administrationFee')?.touched && 
                      propertyDataForm.get('administrationFee')?.hasError('required')">
          Este campo es requerido
        </small>
        <small class="error-message" *ngIf="propertyDataForm.get('administrationFee')?.touched && 
                      propertyDataForm.get('administrationFee')?.hasError('min')">
          El valor debe ser mayor a 0
        </small>
      </div>
    </div>

    <button type="submit" 
    [disabled]="!propertyDataForm.valid" 
    class="continue-button">
    {{((loginRole == 2 && !isLinked) || currentStep !== 2) ? 'Continuar' : 'Grabar Información'}}
    <!-- {{(loginRole !== 2 || currentStep !== 2) ? 'Grabar Información' : 'Continuar'}} -->
    </button>
  </form>

  <!-- Formularios de Vinculación -->
  <form *ngIf="((currentStep === 2 && role === 1) || (currentStep === 3)) && tenantDataForm"
    [formGroup]="tenantDataForm" (ngSubmit)="onSubmit()" class="form-container">
    <button class="close-button" (click)="goBack()">×</button>

    <div class="note" *ngIf="currentStep <= steps.length && steps[currentStep - 1]">
      <strong>NOTA:</strong> {{steps[currentStep - 1].description}}
    </div>

    <!-- Para propietario vinculando arrendatario o arrendatario vinculando propietario -->
    <ng-container
      *ngIf="(role === 2 && currentStep === 3 && radicationMainRole === 2 && isLinked === 0) || 
            (role === 1 && currentStep === 2 && radicationMainRole === 1 && isLinked === 0)">
      <div class="form-row two-columns" [formGroupName]="'vinculado'">
        <div class="form-group">
          <label>Número Celular: <span class="required-field">*</span></label>
          <input type="tel" formControlName="mobilePhone">
          <small class="error-message" *ngIf="tenantDataForm.get('vinculado.mobilePhone')?.touched && 
             tenantDataForm.get('vinculado.mobilePhone')?.hasError('required')">
            Este campo es requerido
          </small>
        </div>

        <div class="form-group">
          <label>Correo Electrónico: <span class="required-field">*</span></label>
          <input type="email" formControlName="email">
          <small class="error-message" *ngIf="tenantDataForm.get('vinculado.email')?.touched && 
             tenantDataForm.get('vinculado.email')?.hasError('required')">
            Este campo es requerido
          </small>
          <small class="error-message" *ngIf="tenantDataForm.get('vinculado.email')?.touched && 
             (tenantDataForm.get('vinculado.email')?.hasError('email') || 
              tenantDataForm.get('vinculado.email')?.hasError('pattern'))">
            Ingrese un correo electrónico válido
          </small>
        </div>
      </div>
    </ng-container>

    <!-- Para arrendatario vinculando codeudores -->
    <ng-container *ngIf="role === 1 && (
      (currentStep === 3 && radicationMainRole === 1 && isLinked === 0) || 
      (currentStep === 2 && radicationMainRole === 2 && isLinked === 0) ||
      (currentStep === 2 && radicationMainRole === 2 && isLinked === 1 && loginRole === 1)) 
      && quoteData?.inNumeroCodeudores">
    <ng-container *ngFor="let _ of getCodeudorArray(); let i = index">
      <h4 class="codeudor-title">Codeudor {{i + 1}}</h4>
      <div class="form-row two-columns" [formGroupName]="'codeudor' + i">
          <div class="form-group">
            <label>Número Celular: <span class="required-field">*</span></label>
            <input type="tel" formControlName="mobilePhone">
            <small class="error-message" *ngIf="tenantDataForm.get('codeudor' + i + '.mobilePhone')?.touched && 
               tenantDataForm.get('codeudor' + i + '.mobilePhone')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Correo Electrónico: <span class="required-field">*</span></label>
            <input type="email" formControlName="email">
            <small class="error-message" *ngIf="tenantDataForm.get('codeudor' + i + '.email')?.touched && 
               tenantDataForm.get('codeudor' + i + '.email')?.hasError('required')">
              Este campo es requerido
            </small>
            <small class="error-message" *ngIf="tenantDataForm.get('codeudor' + i + '.email')?.touched && 
               (tenantDataForm.get('codeudor' + i + '.email')?.hasError('email') || 
                tenantDataForm.get('codeudor' + i + '.email')?.hasError('pattern'))">
              Ingrese un correo electrónico válido
            </small>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <!-- <button type="submit" [disabled]="!tenantDataForm.valid" class="continue-button">
      {{(currentStep === steps.length) ? 'Grabar Información' : 'Continuar'}}
    </button> -->

    <button type="submit" 
    [disabled]="currentStep === 2 && role === 1 && loginRole === 1 && isLinked === 0 
      ? !tenantDataForm.get('vinculado')?.valid 
      : !tenantDataForm.valid" 
    class="continue-button">
    {{(currentStep === steps.length) ? 'Grabar Información' : 'Continuar'}}
  </button>


  </form>

</div>